'use client';

import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useRef } from 'react';
import { useShallow } from 'zustand/shallow';
import { useLockedBody, useOnClickOutside } from '@/libs/hooks';
import { MODAL, useUiState } from '@/store';
import { AppInfoModal } from './appInfo';
export const Modal = () => {
  const [_modal, _onClearModal] = useUiState(useShallow(st => [st.modal, st.onClearModal]));
  const $modal = useRef<HTMLDivElement | null>(null);
  useOnClickOutside<HTMLDivElement>($modal, () => _onClearModal());
  const [_locked, setLocked] = useLockedBody();
  useEffect(() => {
    setLocked(_modal !== undefined);
  }, [_modal, setLocked]);
  return <AnimatePresence>
      {_modal !== undefined && <motion.div animate={{
      opacity: 1
    }} className='fixed top-0 left-0 z-100 flex h-dvh w-dvw items-center justify-center bg-background/60 backdrop-blur-lg' exit={{
      opacity: 0
    }} initial={{
      opacity: 0
    }}>
          {_modal === MODAL.APP_INFO && <AppInfoModal _onClearModal={_onClearModal} $ref={$modal} />}
        </motion.div>}
    </AnimatePresence>;
};